import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import { ErrorHttpResponse, HttpConfig } from '../../../../models/https';
import useHttps from '../../../useHttps';
import useGetNotifications from './useGetNotifications';
import toast from 'react-hot-toast';

const useMarkAllAsRead = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const { getNotifications } = useGetNotifications();

  const onMarkAllAsReadError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while marking notifications as read'
    );
    toast.error('Something went wrong while marking notifications as read');
  };

  const onMarkAllAsReadSuccess = useCallback(
    (response: any) => {
      toast.success(response.message);
      getNotifications();
    },
    [getNotifications]
  );

  const markAllAsRead = useCallback(() => {
    const url: HttpConfig = {
      url: 'notifications', // same endpoint
      method: 'patch', // using PATCH method for updates
    };

    return request(
      url,
      onMarkAllAsReadSuccess,
      setLoading,
      onMarkAllAsReadError
    );
  }, [request, onMarkAllAsReadSuccess]);

  return { markAllAsRead, loading };
};

export default useMarkAllAsRead;
